import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NewsItem } from '../../shared/models/NewsItem';
import { User } from '../../shared/models/User';
import { GlobalService } from '../../shared/services/global';
import { HttpService } from '../../shared/services/HttpService';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from '../../shared/components/modal/modal.component';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.css']
})
export class NewsComponent implements OnInit {
  CurUser: User;
  NewsList: NewsItem[];
  PageIndex: number;
  PageSize: number;
  ItemCount: number;
  faPenToSquare = faPenToSquare;
  CurrentOpenDialog: MatDialogRef<ModalComponent, any>;
  readonly PageSizeOptions: number[] = [5, 10, 20, 50];

  constructor(private http: HttpService, private global: GlobalService, private router: Router, public matDialog: MatDialog) { }

  ngOnInit(): void {
    this.PageSize = 20;
    this.PageIndex = 0;
    this.global.getCurrentUser().then(x => {
      this.CurUser = x;

      if (this.CurUser && this.CurUser != null) {
        this.LoadNewsItems(false);
      }
      else {
        this.router.navigate(['/']);
      }
    });

  }

  LoadNewsItems(resetIndex:boolean) {
    this.http.GetNewsItems(this.PageIndex, this.PageSize).then(x => {
      if (resetIndex) {
        this.PageIndex = 0;
      }      
      this.ItemCount = x.ItemCount;
      this.NewsList = x.Items;
    });
  }

  SaveNewsItem(item: NewsItem) {
    this.http.AddNewsItem(item).then(x => {
      if (x.StatusCode == "200") {
        this.LoadNewsItems(true);
      }
      else {
        //show error message
      }
    });
  }

  EditNewsItem(item: NewsItem) {


    var dialogConfig = this.GetDialogConfig("NewNewsItem");

    var newsItemObject = { type: "NewsItem", object: item };
    dialogConfig.data = newsItemObject;

    this.CurrentOpenDialog = this.matDialog.open<ModalComponent>(ModalComponent, dialogConfig);

    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.addListener("closeEvent", (event) => {
      this.CloseModal();
    });
    this.CurrentOpenDialog.componentInstance.ActionEventEmitter.addListener("actionEvent", (event) => {
      this.SaveNewsItem(event);
      this.CloseModal();
    });
  }

  GetDialogConfig(name: string): MatDialogConfig {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = name;
    dialogConfig.height = "80%";
    dialogConfig.width = "80%";

    return dialogConfig;
  }

  CloseModal() {
    this.CurrentOpenDialog.close();
    this.CurrentOpenDialog.componentInstance.CloseEventEmitter.removeAllListeners();
    this.CurrentOpenDialog = null;
  }

  DeleteNewsItem(item: NewsItem) {
    this.http.DeleteNewsItem(item.NewsItemID, this.CurUser.UserId.toString()).then(x => {
      this.LoadNewsItems(false);
    });
  }

  GoToArticle(item: NewsItem) {
    window.open(item.Link, '_blank');
  }

  PageEvent(event: any) {
    this.PageIndex = event.pageIndex;
    this.PageSize = event.pageSize;
    this.LoadNewsItems(false);
  }

}
